import { SatPracticeSetScreen } from '@/components/SatPracticeSetScreen';
import { SatPracticeTestSection } from '@/components/SatPracticeTestSection';
import { SatScoreTrackingSection } from '@/components/SatScoreTrackingSection';
import { SatStatsBand } from '@/components/SatStatsBand';
import { SatTutoringSection } from '@/components/SatTutoringSection';
import { StoryStage } from '@/components/marketing/StoryStage';
import { SatAboutAnswers } from './SatAboutAnswers';
import { SatAboutClose } from './SatAboutClose';
import { SatAboutHero } from './SatAboutHero';

const TITLE = 'Inside the Free SAT Course | Mentara';
const DESCRIPTION =
  'See what is inside the free SAT course: a short diagnostic, a course that re-orders around your weakest area, practice that aims there, and a full-length Bluebook baseline. No account needed. Add a 1-on-1 tutor when you want one.';
const URL = 'https://mentaratutors.com/what-we-do/sat/about/';
const IMAGE = 'https://mentaratutors.com/logos/mentara-full-light.png';

/**
 * /what-we-do/sat/about/ (spec 010 §5.4): what is inside the free course, funnelling into it.
 * Order: Starting Line, Story Stage, three Real Screens, Facts Band, tutoring Real Screen,
 * Straight Answers, Close. The intake form is demoted into a collapsed <details> in the
 * tutoring section; nothing above the fold is a form.
 */
export const SatLandingPage = () => {
  return (
    <>
      <title>{TITLE}</title>
      <meta name="description" content={DESCRIPTION} />
      <meta
        name="keywords"
        content="free SAT course, free SAT prep, SAT diagnostic, SAT practice questions, digital SAT, Bluebook practice test, SAT tutoring"
      />
      <link rel="canonical" href={URL} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={URL} />
      <meta property="og:title" content={TITLE} />
      <meta property="og:description" content={DESCRIPTION} />
      <meta property="og:image" content={IMAGE} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={URL} />
      <meta property="twitter:title" content={TITLE} />
      <meta property="twitter:description" content={DESCRIPTION} />
      <meta property="twitter:image" content={IMAGE} />

      <div className="bg-background">
        <SatAboutHero />

        <div className="mx-auto w-full max-w-6xl px-4 pb-14 sm:px-6 lg:pb-20">
          <StoryStage captions="long" />
        </div>

        <SatScoreTrackingSection />
        <SatPracticeSetScreen />
        <SatPracticeTestSection />
        <SatStatsBand />
        <SatTutoringSection />
        <SatAboutAnswers />
        <SatAboutClose />
      </div>
    </>
  );
};
